var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCertified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.068,
    height: 25.261,
    viewBox: "0 0 21.068 25.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368",
    transform: "translate(-1742.099 -459.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M1743.66,467.044v-4.711a2.184,2.184,0,0,1,2.182-2.189h14.105a2.185,2.185,0,0,1,2.186,2.186v16.3a2.186,2.186,0,0,1-2.186,2.186h-7.7",
    transform: "translate(0.285)",
    fill: "none",
    stroke: "#767983",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    x2: 5.814,
    transform: "translate(1753.954 468.102)",
    fill: "none",
    stroke: "#767983",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M1750.18,473.671v6.614l-2.968-2.148-2.882,2.148v-6.614",
    transform: "translate(0.47 2.876)",
    fill: "#fff",
    stroke: "#767983",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    d: "M5.18,0A5.18,5.18,0,1,1,0,5.18,5.18,5.18,0,0,1,5.18,0Z",
    transform: "translate(1742.599 468.103)",
    fill: "#767983",
    stroke: "#767983",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    x2: 3.814,
    transform: "translate(1755.954 472.325)",
    fill: "none",
    stroke: "#767983",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    x2: 13.17,
    transform: "translate(1746.596 463.881)",
    fill: "none",
    stroke: "#767983",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    x2: 2.9,
    transform: "translate(1756.868 476.547)",
    fill: "none",
    stroke: "#767983",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M1746.461,473.236l-.673-.751q-.636-.708-1.269-1.416a.7.7,0,0,1,.453-1.168.677.677,0,0,1,.591.244l.925,1.031.089.1.1-.085,2.546-2.267a.7.7,0,1,1,.989.979.539.539,0,0,1-.046.043q-1.832,1.638-3.671,3.271Z",
    transform: "translate(0.466 2.3)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertified);
export default __webpack_public_path__ + "static/media/icon-certified.962666a5.svg";
export { ForwardRef as ReactComponent };